// config
import { appConfig } from '../../config/app-config';

export const mangelConfig = {
   debugMode: false,
   dbPessimisticUpdate: true
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/config/mangel.config.ts